import { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Link,
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Hidden
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import AddIcon from '@material-ui/icons/Add';
import HomeIcon from '@material-ui/icons/Home';
import UsersIcon from '@material-ui/icons/SupervisorAccount';
import GroupsIcon from '@material-ui/icons/SupervisedUserCircle';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import ViewQuiltIcon from '@material-ui/icons/ViewQuilt';
import BoardDialog from './BoardDialog';
import { SignOutButton } from './SignOutButton';
import { useUser } from '../contexts/user-context';
import { useStyles } from '../theme';
import { useIsFeatureFlagEnabled } from '../contexts/feature-flag-context';

const styles = () => ({
  root: {
    flexGrow: 1
  },
  flex: {
    flexGrow: 1
  },
  menuButton: {
    marginLeft: -5
  },
  noShadow: {
    boxShadow: 'none'
  },
  list: {
    width: 250
  },
  appBar: {
    flexGrow: 1,
    maxHeight: 60
  },
  headerLink: {
    color: '#FFF'
  },
  title: {
    flexGrow: 1
  },
  userIcon: {
    verticalAlign: 'top'
  },
  email: {
    paddingLeft: 5
  }
});

export const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [createFormOpen, setCreateFormOpen] = useState(false);

  const isTestEnabled = useIsFeatureFlagEnabled('vip_fe_test');

  const classes = useStyles(styles);

  const {
    isLoggedIn,
    hasRoles,
    user: { email, name }
  } = useUser();

  const toggleDrawer = (open) => () => {
    setMenuOpen(open);
  };

  const handleCreateBoard = () => {
    setCreateFormOpen(true);
  };
  const handleFormClose = () => {
    setCreateFormOpen(false);
  };

  const UserButton = () => (
    <IconButton
      color="inherit"
      aria-label={`${email} settings`}
      component="a"
      href="/me"
    >
      <AccountCircleIcon />
      <Hidden smDown>
        <Typography
          noWrap
          variant="body2"
          align="right"
          className={classes.email}
        >
          {isTestEnabled ? name : email}
        </Typography>
      </Hidden>
    </IconButton>
  );

  const MenuButton = () => (
    <IconButton
      className={classes.menuButton}
      color="inherit"
      aria-label="Menu"
      onClick={toggleDrawer(true)}
    >
      <MenuIcon />
    </IconButton>
  );

  const AdminOptions = () => (
    <span>
      <Divider />
      <ListItem button component="a" href="/users">
        <ListItemIcon>
          <UsersIcon />
        </ListItemIcon>
        <ListItemText primary="Users" />
      </ListItem>
      <ListItem button component="a" href="/groups">
        <ListItemIcon>
          <GroupsIcon />
        </ListItemIcon>
        <ListItemText primary="Groups" />
      </ListItem>
    </span>
  );

  const ManagerOptions = () => (
    <div>
      <ListItem button onClick={handleCreateBoard}>
        <ListItemIcon>
          <AddIcon />
        </ListItemIcon>
        <ListItemText primary="Create New Board" />
      </ListItem>
      <ListItem button component="a" href="/boards">
        <ListItemIcon>
          <ViewQuiltIcon />
        </ListItemIcon>
        <ListItemText primary="All Boards" />
      </ListItem>
    </div>
  );

  return (
    <div className={classes.appBar}>
      <AppBar position="static" className={classes.noShadow}>
        <Toolbar>
          {isLoggedIn && <MenuButton />}
          <Typography
            variant="h6"
            color="inherit"
            noWrap
            className={classes.title}
          >
            <Link component={RouterLink} to="/" className={classes.headerLink}>
              Roadie Dashboard
            </Link>
          </Typography>
          {isLoggedIn && <UserButton />}
        </Toolbar>
      </AppBar>
      <Drawer open={menuOpen} onClose={toggleDrawer(false)}>
        <div tabIndex={0} role="button">
          <div className={classes.list}>
            <List>
              <ListItem button component="a" href="/">
                <ListItemIcon>
                  <HomeIcon />
                </ListItemIcon>
                <ListItemText primary="Home" />
              </ListItem>
              {hasRoles(['admin', 'dashboard_admin', 'dashboard_manager']) && <ManagerOptions />}
              {hasRoles(['admin', 'dashboard_admin']) && <AdminOptions />}
              <Divider />
              {isLoggedIn && <SignOutButton />}
            </List>
          </div>
        </div>
      </Drawer>
      <BoardDialog
        newBoard
        board={{}}
        open={createFormOpen}
        formCloseHandler={handleFormClose}
      />
    </div>
  );
};
